<template>
  <div class="container-fluid px-0">
    <div class="row content mx-0">
      <div class="col col-md-1 col-xl-1 col-xxl-1 px-0"></div>
      <div class="col-12 col-md-10 col-xl-10 col-xxl-10 px-3 pb-3">
        <div class="row mx-0">
          <div class="col-12 px-0 text-end my-2 mes-update-time">
            <span class="my-0" id="mes-update-time">更新時間:</span>
            <span class="my-0" for="mes-update-time">
              {{ nowTime }}
            </span>
          </div>

          <div class="col-12 px-0 text-start elecBoard-main-title">
            <div>
              <template v-if="tabIndex == 0">即時資訊</template
              ><template v-else-if="tabIndex == 1">開機稼動率</template>-{{
                siteName
              }}
            </div>
          </div>
          <div class="row mx-0 px-0">
            <div
              class="col-12 col-xxl-1 px-0 elecBoard-sub-title order-1 order-xxl-1"
            >
              <div class="my-3">
                {{ operName }}
              </div>
              <div
                v-for="(item, key) in userArray"
                :key="key"
                class="mb-3 elecBoard-oper-img"
              >
                <img
                  :src="item.image"
                  class="mx-auto mb-1"
                  alt="Center image"
                />
                <p class="elecBoard-user-name">
                  {{ item.position + ":" + item.name }}
                </p>
              </div>
            </div>
            <div class="col-12 col-xxl-10 px-0 order-3 order-xxl-2">
              <nav class="px-0">
                <div class="nav nav-tabs mes-tabs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link mes-tab"
                    :class="{ active: tabIndex == 0 }"
                    id="nav-instant-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-instant"
                    type="button"
                    role="tab"
                    aria-controls="nav-instant"
                    aria-selected="true"
                    @click="tabIndex = 0"
                  >
                    即時資訊
                  </button>
                  <button
                    class="nav-link mes-tab"
                    :class="{ active: tabIndex == 1 }"
                    id="nav-activation-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-activation"
                    type="button"
                    role="tab"
                    aria-controls="nav-activation"
                    aria-selected="false"
                    @click="tabIndex = 1"
                  >
                    開機稼動率
                  </button>
                  <elecBoardGroupTab />
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">
                <div
                  class="tab-pane fade"
                  :class="{
                    'show active': tabIndex == 0,
                  }"
                  style="overflow-x: auto"
                  id="nav-instant"
                  role="tabpanel"
                  aria-labelledby="nav-instant-tab"
                >
                  <div class="row mx-0 elecBoard-row" style="min-width: 1180px">
                    <div
                      class="col-12 px-0"
                      style="background-color: #646569; color: #ffffff"
                    >
                      <table style="width: 100%">
                        <tr>
                          <td
                            style="
                              min-width: 64px;
                              width: 64px;
                              text-align: right;
                              padding-right: 10px;
                            "
                          >
                            入料區
                          </td>
                          <td style="min-width: 66px; width: 66px">前清洗區</td>
                          <td style="min-width: 270px; width: 270px">淬火區</td>
                          <td style="min-width: 66px; width: 66px">後清洗區</td>
                          <td style="min-width: 230px; width: 230px">回火區</td>
                          <td style="min-width: 50px; width: 50px">收料區</td>
                        </tr>
                      </table>
                    </div>
                    <!-- 機台明細 -->
                    <template v-for="col in 2" :keys="col">
                      <template v-for="index in colCount" :keys="index">
                        <template
                          v-if="
                            deviceData[
                              deviceArray[index - 1 + (col - 1) * colCount]
                            ]
                          "
                        >
                          <div
                            class="col-12 px-0"
                            style="
                              left: 0px;
                              width: 100%;
                              height: 190px;
                              position: relative;
                            "
                            :style="{
                              'background-color':
                                deviceData[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ].status == 'R'
                                  ? 'rgba(0, 177, 82, .3)'
                                  : 'rgba(100, 101, 105, 0.3)',
                            }"
                          >
                            <img
                              :src="
                                deviceImage[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ]
                              "
                              alt=""
                              style="
                                width: 100%;
                                height: auto;
                                object-fit: contain;
                              "
                            />
                            <div
                              style="
                                height: 100%;
                                width: 97%;
                                position: absolute;
                                left: 2%;
                                top: 0;
                              "
                            >
                              <div
                                v-for="(workItem, itemIndex) in ht_work_display[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ].work_schedule"
                                :key="itemIndex"
                                :id="workItem.work_code + '-mes-elecBoard-heat'"
                                :style="{
                                  color: '#fff',
                                  height: '2.5rem',
                                  width: workItem.first - workItem.last + '%',
                                  'line-height': '2.5rem',
                                  minWidth: '1%',
                                  position: 'absolute',
                                  left: workItem.last + '%',
                                  top: '15%',
                                  backgroundColor: '#00b152',
                                  overflow: 'hidden',
                                  cursor: 'default',
                                  transition: ht_work_display[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].transition
                                    ? 'all 0.5s'
                                    : 'none',
                                }"
                                data-bs-toggle="popover"
                                data-bs-trigger="hover focus"
                                data-bs-placement="bottom"
                                data-bs-custom-class="elecboard-popover"
                                :data-bs-content="
                                  workItem.org_code == ''
                                    ? workItem.work_code
                                    : workItem.org_code
                                "
                                @mouseover="
                                  setPopover(
                                    workItem.work_code + '-mes-elecBoard-heat'
                                  )
                                "
                                @mouseleave="
                                  killPopover(
                                    workItem.work_code + '-mes-elecBoard-heat'
                                  )
                                "
                              >
                                {{
                                  workItem.org_code == ""
                                    ? workItem.work_code
                                    : workItem.org_code
                                }}
                              </div>
                            </div>
                            <commonColCard
                              style="position: absolute; top: 80px; border: 0"
                              v-if="
                                deviceData[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ]
                              "
                              :colTitle="{ 'elecBoard-heat-col-title': true }"
                              :colTitleTop="{
                                'elecBoard-col-title-name-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-name-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-name-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-name-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-name-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-name-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-name-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-name-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-name-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-status-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-status-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-status-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-status-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-status-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-status-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-status-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-status-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].device_name_tw
                                }}</template
                              >
                              <template #col-title-bottom>
                                {{
                                  totalDeviceStatus[
                                    deviceData[
                                      deviceArray[
                                        index - 1 + (col - 1) * colCount
                                      ]
                                    ].status
                                  ].text
                                }}</template
                              >
                              <template #col-title-body>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-end elecBoard-col-detail"
                                  >
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button"
                                        @click="
                                          query_detail(
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ],
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].oper
                                          )
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                          </div>
                          <div class="col-12" style="padding-right: 7.5%">
                            <table style="width: 100%">
                              <tr style="background-color: #e8e8ea">
                                <td
                                  style="
                                    width: 70px;
                                    min-width: 70px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #646569;
                                  "
                                >
                                  設定值
                                </td>
                                <td
                                  v-for="(set_item, set_key) in deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].machine_detail_set"
                                  :key="set_key"
                                  style="
                                    min-width: 52px;
                                    width: 52px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #646569;
                                  "
                                >
                                  {{ set_item }}
                                </td>
                              </tr>
                              <tr style="background-color: #fff">
                                <td
                                  style="
                                    width: 70px;
                                    min-width: 70px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #4b8c80;
                                  "
                                >
                                  實際值
                                </td>
                                <td
                                  v-for="(act_item, act_key) in deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].machine_detail_act"
                                  :key="act_key"
                                  style="
                                    width: 52px;
                                    min-width: 52px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #646569;
                                  "
                                  :style="{
                                    'background-color':
                                      act_key == 2 ||
                                      act_key == 3 ||
                                      act_key == 12 ||
                                      act_key == 13 ||
                                      act_key == 17
                                        ? '#fff'
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] > 100
                                        ? deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            30 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            30 >
                                            act_item
                                          ? '#fff' //暫時隱藏異常 #c10000
                                          : deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] +
                                              15 <
                                              act_item ||
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] -
                                              15 >
                                              act_item
                                          ? '#fff' //暫時隱藏異常 #ffc100
                                          : '#fff'
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] < 1
                                        ? deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            0.1 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            0.1 >
                                            act_item
                                          ? '#fff' //暫時隱藏異常 #c10000
                                          : deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] +
                                              0.05 <
                                              act_item ||
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] -
                                              0.05 >
                                              act_item
                                          ? '#fff' //暫時隱藏異常 #ffc100
                                          : '#fff'
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            20 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            20 >
                                            act_item
                                        ? '#fff' //暫時隱藏異常 #c10000
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            10 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            10 >
                                            act_item
                                        ? '#fff' //暫時隱藏異常 #ffc100
                                        : '#fff',
                                    color:
                                      act_key == 2 ||
                                      act_key == 3 ||
                                      act_key == 12 ||
                                      act_key == 13 ||
                                      act_key == 17
                                        ? '#4b8c80'
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] > 100
                                        ? deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            30 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            30 >
                                            act_item
                                          ? '#4b8c80' //暫時隱藏異常 #fff
                                          : deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] +
                                              15 <
                                              act_item ||
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] -
                                              15 >
                                              act_item
                                          ? '#4b8c80' //暫時隱藏異常 #646569
                                          : '#4b8c80'
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] < 1
                                        ? deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            0.1 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            0.1 >
                                            act_item
                                          ? '#4b8c80' //暫時隱藏異常 #fff
                                          : deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] +
                                              0.05 <
                                              act_item ||
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].machine_detail_set[act_key] -
                                              0.05 >
                                              act_item
                                          ? '#4b8c80' //暫時隱藏異常 #646569
                                          : '#4b8c80'
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            20 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            20 >
                                            act_item
                                        ? '#4b8c80' //暫時隱藏異常 #fff
                                        : deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] +
                                            10 <
                                            act_item ||
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].machine_detail_set[act_key] -
                                            10 >
                                            act_item
                                        ? '#4b8c80' //暫時隱藏異常 #646569
                                        : '#4b8c80',
                                  }"
                                >
                                  {{ act_item }}
                                </td>
                              </tr>
                            </table>
                          </div>
                          <hr
                            class="m-0"
                            style="border-top: 3px solid #4b8c80; opacity: 1"
                          />
                        </template>
                        <template
                          v-else-if="
                            deviceArray[index - 1 + (col - 1) * colCount]
                          "
                        >
                          <div
                            class="col-12 px-0"
                            style="
                              left: 0px;
                              width: 100%;
                              height: 190px;
                              position: relative;
                              background-color: rgba(100, 101, 105, 0.3);
                            "
                          >
                            <img
                              :src="
                                deviceImage[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ]
                              "
                              alt=""
                              style="
                                width: 100%;
                                height: auto;
                                object-fit: contain;
                              "
                            />
                            <commonColCard
                              style="position: absolute; top: 80px; border: 0"
                              v-if="
                                deviceArray[index - 1 + (col - 1) * colCount]
                              "
                              :colTitle="{ 'elecBoard-heat-col-title': true }"
                              :colTitleTop="{
                                'elecBoard-col-title-name-S': true,
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-S': true,
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                }}</template
                              >
                              <template #col-title-bottom>未導入</template>
                              <template #col-title-body>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-end elecBoard-col-detail"
                                  >
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button elecBoard-detail-button-default"
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                          </div>
                          <div class="col-12" style="padding-right: 7.5%">
                            <table style="width: 100%">
                              <tr style="background-color: #e8e8ea">
                                <td
                                  style="
                                    width: 70px;
                                    min-width: 70px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #646569;
                                  "
                                >
                                  設定值
                                </td>
                                <td
                                  v-for="n in 17"
                                  style="
                                    min-width: 52px;
                                    width: 52px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #646569;
                                  "
                                >
                                  -
                                </td>
                              </tr>
                              <tr style="background-color: #fff">
                                <td
                                  style="
                                    width: 70px;
                                    min-width: 70px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #4b8c80;
                                  "
                                >
                                  實際值
                                </td>
                                <td
                                  v-for="n in 17"
                                  style="
                                    width: 52px;
                                    min-width: 52px;
                                    border: 0.8pt solid #dcdcde;
                                    color: #646569;
                                  "
                                >
                                  -
                                </td>
                              </tr>
                            </table>
                          </div>
                          <hr
                            class="m-0"
                            style="border-top: 3px solid #4b8c80; opacity: 1"
                          />
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  :class="{
                    'show active': tabIndex == 1,
                  }"
                  id="nav-activation"
                  role="tabpanel"
                  aria-labelledby="nav-activation-tab"
                >
                  <div class="row mx-0 elecBoard-row">
                    <template v-for="col in 2" :keys="col">
                      <div class="col-12 px-0">
                        <div class="row mx-0">
                          <template v-for="index in colCount" :keys="index">
                            <commonColCard
                              v-if="
                                deviceData[
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                ]
                              "
                              :colTitleTop="{
                                'elecBoard-col-title-name-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-name-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-name-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-name-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-name-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-name-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-name-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-name-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-name-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-R':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'R' ||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-', //2026.04.21 by Tivon
                                'elecBoard-col-title-status-Q':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'Q',
                                'elecBoard-col-title-status-H':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'H',
                                'elecBoard-col-title-status-S':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'S' /*||
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == '-'*/, //2026.04.21 by Tivon
                                'elecBoard-col-title-status-A':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'A',
                                'elecBoard-col-title-status-C':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'C',
                                'elecBoard-col-title-status-M':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'M',
                                'elecBoard-col-title-status-E':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'E',
                                'elecBoard-col-title-status-D':
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].status == 'D',
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceData[
                                    deviceArray[
                                      index - 1 + (col - 1) * colCount
                                    ]
                                  ].device_name_tw
                                }}</template
                              >
                              <template #col-title-bottom>
                                {{
                                  totalDeviceStatus[
                                    deviceData[
                                      deviceArray[
                                        index - 1 + (col - 1) * colCount
                                      ]
                                    ].status
                                  ].text
                                }}</template
                              >
                              <template #col-title-body>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span
                                        >待機時間:{{
                                          deviceData[
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ]
                                          ].device_queue_time
                                        }}</span
                                      >
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button"
                                        @click="
                                          query_detail(
                                            deviceArray[
                                              index - 1 + (col - 1) * colCount
                                            ],
                                            deviceData[
                                              deviceArray[
                                                index - 1 + (col - 1) * colCount
                                              ]
                                            ].oper
                                          )
                                        "
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="
                                        deviceData[
                                          deviceArray[
                                            index - 1 + (col - 1) * colCount
                                          ]
                                        ].stack_bar_information
                                      "
                                      :stacksSize="'midle'"
                                    />
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                            <commonColCard
                              v-else-if="
                                deviceArray[index - 1 + (col - 1) * colCount]
                              "
                              :colTitleTop="{
                                'elecBoard-col-title-name-S': true,
                              }"
                              :colTitleBottom="{
                                'elecBoard-col-title-status-S': true,
                              }"
                            >
                              <template #col-title-top>
                                {{
                                  deviceArray[index - 1 + (col - 1) * colCount]
                                }}</template
                              >
                              <template #col-title-bottom>未導入</template>
                              <template #col-title-body>
                                <div class="row mx-0 elecBoard-col-default">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <div>
                                      <span>待機時間:</span>
                                      <span>-</span>
                                    </div>
                                    <div>
                                      <button
                                        type="button"
                                        class="btn elecBoard-detail-button elecBoard-detail-button-default"
                                      >
                                        明細
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row mx-0 elecBoard-col-default">
                                  <div
                                    class="col-12 px-0 d-flex justify-content-between elecBoard-col-detail"
                                  >
                                    <stackBar
                                      :stacksBarClass="stacksBarClass"
                                      :stacksBarMaxValue="stacksBarMaxValue"
                                      :stacksData="stacksBarDefault"
                                      :stacksSize="'midle'"
                                    />
                                  </div>
                                </div>
                              </template>
                            </commonColCard>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-xxl-1 px-0 order-2 order-xxl-3">
              <!-- 即時狀態 -->
              <deviceStatus
                :totalDeviceStatus="totalDeviceStatus"
                :deviceArrayLength="deviceArray.length"
              ></deviceStatus>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-md-1 col-xl-1 col-xxl-1 px-0"></div>
    </div>
  </div>
</template>

<script>
import { Popover } from "bootstrap";
import { useStore } from "vuex";
import { computed, inject } from "@vue/runtime-core";
import elecBoardGroupTab from "@/components/elecBoardGroupTab.vue";
import deviceStatus from "@/components/deviceStatus.vue";
import commonColCard from "@/components/commonColCard.vue";
import stackBar from "@/components/stackBar.vue";
import { ref, watch } from "vue";
export default {
  components: {
    elecBoardGroupTab,
    deviceStatus,
    commonColCard,
    stackBar,
  },
  setup() {
    const store = useStore();

    //getters
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = computed(
      () => store.getters["stackBar/get_stacksBarMaxValue"]
    );
    const stacksBarDefault = computed(
      () => store.getters["stackBar/get_stacksBarDefault"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
    };

    const siteName = inject("siteName");
    const oper = inject("oper");
    const operName = inject("operName");
    const deviceName = inject("deviceName");
    const detail = inject("detail");
    const userArray = inject("userArray");
    const colCount = inject("colCount");
    const deviceArray = inject("deviceArray");
    const totalDeviceStatus = inject("totalDeviceStatus");
    const deviceData = inject("deviceData");
    const tabIndex = inject("tabIndex");

    const nowTime = inject("nowTime");

    const deviceImageGroup = {
      heatTreatmentImage2: require("@/assets/heat-treatment2.png"), //有回火5區
      heatTreatmentImageD2: require("@/assets/heat-treatmentD2.png"), //D2爐
      heatTreatmentImageA: require("@/assets/heat-treatmentA.png"), //無烘乾，有回火5區
      heatTreatmentImageB: require("@/assets/heat-treatmentB.png"), //無回火5區的(只到4區)
      heatTreatmentImageC: require("@/assets/heat-treatmentC.png"), //C爐
      heatTreatmentImageD: require("@/assets/heat-treatmentD.png"), //用無回火5區的(只到4區，且無焠火5.6區)
      heatTreatmentImageE: require("@/assets/heat-treatmentE.png"), //E爐
    };
    const deviceImage = ref({});
    const ht_work_display = ref([]);
    const popoverObj = ref({});

    const query_detail = (thisDeviceName, thisOper) => {
      deviceName.value = thisDeviceName;
      oper.value = thisOper;
      detail.value = true;
    };

    const obHeatTreatmentWork = () => {
      let sensorZoneView = {
        GEI80: {
          width: 5,
          accumulate: 0,
        },
        QXJ80: {
          width: 9,
          accumulate: 5,
        },
        "RXWG9-80X1000X12": {
          width: 29,
          accumulate: 14,
        },
        TSW100: {
          width: 13,
          accumulate: 43,
        },
        QXJ100: {
          width: 8,
          accumulate: 56,
        },
        "RCWGA6-100X1200X15": {
          width: 34,
          accumulate: 64,
        },
        OUTLET: {
          width: 100,
          accumulate: 0,
        },
      };
      let ht_work_display_data = [];
      let result_Data_Key = Object.keys(deviceData.value);
      result_Data_Key.forEach((item) => {
        if (!ht_work_display_data[item]) {
          ht_work_display_data[item] = {
            work_schedule: [],
            transition: false,
          };
        }
        if (
          deviceData.value[item].hasOwnProperty("work_schedule") &&
          deviceData.value[item].work_schedule.length > 0
        ) {
          deviceData.value[item].work_schedule.forEach(
            (workItem, workIndex) => {
              if (workItem.product_line == 0) {
                //收料區出料
                if (workItem.first) {
                  if (workItem.last) {
                    let firstSensorPoint = workItem.first.sensor.split("_");
                    let firstPosition =
                      workItem.first.sensor_distance /
                      workItem.first.zone_length;

                    let lastSensorPoint = workItem.last.sensor.split("_");
                    let lastPosition =
                      workItem.last.sensor_distance / workItem.last.zone_length;

                    let firstPoint =
                      sensorZoneView[firstSensorPoint[0]].width *
                        firstPosition +
                      sensorZoneView[firstSensorPoint[0]].accumulate;

                    let lastPoint =
                      sensorZoneView[lastSensorPoint[0]].width * lastPosition +
                      sensorZoneView[lastSensorPoint[0]].accumulate;

                    let work_code_obj = {
                      first: Number(firstPoint.toFixed(2)),
                      last: Number(lastPoint.toFixed(2)),
                      work_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_code,
                      org_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  } else {
                    let firstSensorPoint = workItem.first.sensor.split("_");
                    let firstPosition =
                      workItem.first.sensor_distance /
                      workItem.first.zone_length;

                    let firstPoint =
                      sensorZoneView[firstSensorPoint[0]].width *
                        firstPosition +
                      sensorZoneView[firstSensorPoint[0]].accumulate;

                    let work_code_obj = {
                      first: Number(firstPoint.toFixed(2)),
                      last: 0,
                      work_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_code,
                      org_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  }
                } else {
                  if (workItem.last) {
                    let lastSensorPoint = workItem.last.sensor.split("_");
                    let lastPosition =
                      workItem.last.sensor_distance / workItem.last.zone_length;

                    let lastPoint =
                      sensorZoneView[lastSensorPoint[0]].width * lastPosition +
                      sensorZoneView[lastSensorPoint[0]].accumulate;

                    let work_code_obj = {
                      first: 100,
                      last: Number(lastPoint.toFixed(2)),
                      work_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_code,
                      org_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  } else {
                    if (deviceData.value[item].hasOwnProperty("work_in_time")) {
                      if (
                        deviceData.value[item].work_in_time[workIndex].first !=
                          "" &&
                        deviceData.value[item].work_in_time[workIndex].last ==
                          ""
                      ) {
                        let work_code_obj = {
                          first: 100,
                          last: 0,
                          work_code:
                            deviceData.value[item].work_schedule[workIndex]
                              .work_code,
                          org_code:
                            deviceData.value[item].work_schedule[workIndex]
                              .work_org_code,
                        };
                        ht_work_display_data[item].work_schedule.push(
                          work_code_obj
                        );
                      }
                    }
                  }
                }
              } else if (workItem.product_line == 1) {
                //回火區結束出料
                if (workItem.first) {
                  if (workItem.last) {
                    let firstSensorPoint = workItem.first.sensor.split("_");
                    let firstPosition =
                      workItem.first.sensor_distance /
                      workItem.first.zone_length;

                    let lastSensorPoint = workItem.last.sensor.split("_");
                    let lastPosition =
                      workItem.last.sensor_distance / workItem.last.zone_length;

                    let firstPoint =
                      sensorZoneView[firstSensorPoint[0]].width *
                        firstPosition +
                      sensorZoneView[firstSensorPoint[0]].accumulate;

                    let lastPoint =
                      sensorZoneView[lastSensorPoint[0]].width * lastPosition +
                      sensorZoneView[lastSensorPoint[0]].accumulate;

                    let work_code_obj = {
                      first: Number(firstPoint.toFixed(2)),
                      last: Number(lastPoint.toFixed(2)),
                      work_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_code,
                      org_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  } else {
                    let firstSensorPoint = workItem.first.sensor.split("_");
                    let firstPosition =
                      workItem.first.sensor_distance /
                      workItem.first.zone_length;

                    let firstPoint =
                      sensorZoneView[firstSensorPoint[0]].width *
                        firstPosition +
                      sensorZoneView[firstSensorPoint[0]].accumulate;

                    let work_code_obj = {
                      first: Number(firstPoint.toFixed(2)),
                      last: 0,
                      work_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_code,
                      org_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  }
                } else {
                  if (workItem.last) {
                    let lastSensorPoint = workItem.last.sensor.split("_");
                    let lastPosition =
                      workItem.last.sensor_distance / workItem.last.zone_length;

                    let lastPoint =
                      sensorZoneView[lastSensorPoint[0]].width * lastPosition +
                      sensorZoneView[lastSensorPoint[0]].accumulate;

                    let work_code_obj = {
                      first: 80,
                      last: Number(lastPoint.toFixed(2)),
                      work_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_code,
                      org_code:
                        deviceData.value[item].work_schedule[workIndex]
                          .work_org_code,
                    };
                    ht_work_display_data[item].work_schedule.push(
                      work_code_obj
                    );
                  } else {
                    if (deviceData.value[item].hasOwnProperty("work_in_time")) {
                      if (
                        deviceData.value[item].work_in_time[workIndex].first !=
                          "" &&
                        deviceData.value[item].work_in_time[workIndex].last ==
                          ""
                      ) {
                        let work_code_obj = {
                          first: 100,
                          last: 0,
                          work_code:
                            deviceData.value[item].work_schedule[workIndex]
                              .work_code,
                          org_code:
                            deviceData.value[item].work_schedule[workIndex]
                              .work_org_code,
                        };
                        ht_work_display_data[item].work_schedule.push(
                          work_code_obj
                        );
                      }
                    }
                  }
                }
              }
            }
          );
        } else if (
          deviceData.value[item].hasOwnProperty("work_schedule") &&
          deviceData.value[item].work_schedule.length == 0 &&
          deviceData.value[item].hasOwnProperty("work_in_time")
        ) {
          deviceData.value[item].work_in_time.forEach(
            (work_in_time_item, work_in_time_index) => {
              if (
                work_in_time_item.start != "" &&
                work_in_time_item.end == ""
              ) {
                if (work_in_time_item.product_line == 0) {
                  let work_code_obj = {
                    first: 100,
                    last: 0,
                    work_code:
                      deviceData.value[item].work_in_time[work_in_time_index]
                        .work_code,
                    org_code:
                      deviceData.value[item].work_in_time[work_in_time_index]
                        .org_code,
                  };
                  ht_work_display_data[item].work_schedule.push(work_code_obj);
                } else if (work_in_time_item.product_line == 1) {
                  let work_code_obj = {
                    first: 80,
                    last: 0,
                    work_code:
                      deviceData.value[item].work_in_time[work_in_time_index]
                        .work_code,
                    org_code:
                      deviceData.value[item].work_in_time[work_in_time_index]
                        .org_code,
                  };
                  ht_work_display_data[item].work_schedule.push(work_code_obj);
                }
              }
            }
          );
        }
      });
      result_Data_Key.forEach((item) => {
        if (ht_work_display.value[item]) {
          let last_work_code_count =
            ht_work_display.value[item].work_schedule.length;
          let this_work_code_count =
            ht_work_display_data[item].work_schedule.length;
          if (last_work_code_count != this_work_code_count) {
            ht_work_display_data[item].transition = false;
          } else {
            ht_work_display_data[item].transition = true;
          }
        }
        ht_work_display_data[item].work_schedule.sort(htWorkScheduleSort);
      });
      ht_work_display.value = ht_work_display_data;

      result_Data_Key.forEach((item) => {
        deviceImage.value[item] =
          deviceImageGroup[deviceData.value[item].device_image];
      });
    };
    const htWorkScheduleSort = (x, y) => {
      return x.first == y.first ? 0 : x.first > y.first ? 1 : -1;
    };

    // 設置提醒標題並顯示
    const setPopover = (deviceName) => {
      if (document.getElementById(deviceName).dataset.bsContent == "") {
        return;
      }
      popoverObj.value[deviceName] = new Popover(
        document.getElementById(deviceName)
      );
      popoverObj.value[deviceName].show();
    };
    // 清除提醒標題
    const killPopover = (deviceName) => {
      const elements = document.querySelectorAll(
        ".popover.fade.elecboard-popover"
      );
      elements.forEach((element) => {
        element.remove();
      });
    };

    watch(
      deviceData,
      () => {
        obHeatTreatmentWork();
      },
      { deep: true }
    );

    return {
      stacksBarClass,
      stacksBarMaxValue,
      stacksBarDefault,
      siteName,
      operName,
      deviceName,
      detail,
      userArray,
      colCount,
      deviceArray,
      totalDeviceStatus,
      deviceData,
      tabIndex,
      nowTime,
      deviceImage,
      query_detail,
      ht_work_display,
      setPopover,
      killPopover,
    };
  },
};
</script>

<style>
.popover-body {
  padding: 0.5rem 0.75rem;
  font-size: 18px;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
}

.elecboard-popover.popover {
  max-width: unset;
}
.elecboard-popover > .popover-body {
  background-color: rgba(50, 50, 50, 0.7);
  color: var(--main-font-color);
}
.elecboard-popover > .popover-arrow::after {
  border-top-color: rgba(50, 50, 50, 0.7);
  border-bottom-color: rgba(50, 50, 50, 0.7);
}
</style>
